import type {AppLocale} from 'i18n/locales'
import bg from './copy/bg.json'
import en from './copy/en.json'
import de from './copy/de.json'
import tr from './copy/tr.json'
import sv from './copy/sv.json'

export type PromoOfferKey = keyof typeof bg

const bundles: Record<AppLocale, Record<string, string>> = {
  bg: bg as Record<string, string>,
  en: en as Record<string, string>,
  de: de as Record<string, string>,
  tr: tr as Record<string, string>,
  sv: sv as Record<string, string>,
}

export function usePromoOfferCopy(locale: AppLocale) {
  const t = (k: PromoOfferKey): string => {
    const v = bundles[locale]?.[k]
    if (v !== undefined && v !== '') {
      return v
    }
    const enV = bundles.en[k]
    if (enV !== undefined && enV !== '') {
      return enV
    }
    const bgV = bundles.bg[k]
    if (bgV !== undefined && bgV !== '') {
      return bgV
    }
    return k
  }

  const tf = (k: PromoOfferKey, vars: Record<string, string>): string => {
    let s = t(k)
    for (const [key, val] of Object.entries(vars)) {
      s = s.split(`{${key}}`).join(val)
    }
    return s
  }

  return {t, tf}
}
